import React from 'react';
import {
  TextField,
  Box,
  FormControlLabel,
  Grid,
  Checkbox,
  ThemeProvider,
  FormGroup,
  Stack,
} from 'components/base';
import responseInputMuiTheme from 'pages/Forms/Theme/responseInputMuiTheme';
import { AlertMessage } from 'pages/Forms/components/AlertMessage/AlertMessage';
import { selectedActionInputStyles } from 'pages/Forms/Theme/responseInputStyles';
import { FieldsInputTitle } from 'pages/Forms/FormResults/FormResultDetails/ResultInputs/components/common/FieldsInputTitle';
import useCheckboxField from './hooks/useCheckboxField';
import { YesNoNaFormFieldPreviewProps } from '../../type/preview.type';
import { ChoiceImagePreview } from '../ChoiceImagePreview';

const CheckboxFormFieldPreview: React.FC<YesNoNaFormFieldPreviewProps> = ({
  element,
  answer,
  handleDirty,
  updateAnswerInPrefilledElements,
  shouldBeReadOnly,
}) => {
  const theme = responseInputMuiTheme;
  const {
    textFieldRef,
    otherText,
    handleSelectionChange,
    handleOtherTextChange,
    isSelected,
    isShowActionMessage,
    otherChoice,
    isOtherSelected,
  } = useCheckboxField(
    element,
    answer,
    handleDirty,
    updateAnswerInPrefilledElements,
  );

  return (
    <ThemeProvider theme={theme}>
      <Box key={element?.id} m={1}>
        <FieldsInputTitle
          label={element?.label || element?.name}
          isRequired={element?.isRequired}
        />
        <FormGroup>
          <Grid container spacing={1}>
            {element?.choice?.map((choice) => (
              <Grid item key={choice?.id} xs={12} md={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={() => handleSelectionChange(choice?.id)}
                      color="primary"
                      checked={isSelected(choice?.id)}
                    />
                  }
                  label={
                    <Stack justifyContent="center">
                      <ChoiceImagePreview choice={choice} />
                      {choice?.isOtherField
                        ? 'Other (please specify)'
                        : choice?.label}
                    </Stack>
                  }
                  sx={{
                    width: '100%',
                    height: '100%',
                    ...(isSelected(choice?.id) && choice?.action
                      ? selectedActionInputStyles(theme)
                      : {}),
                  }}
                  disabled={shouldBeReadOnly}
                />
              </Grid>
            ))}
          </Grid>
        </FormGroup>

        {isOtherSelected && (
          <Box mt={1}>
            <TextField
              inputRef={textFieldRef}
              key={otherChoice!.id}
              fullWidth
              onChange={(e) => handleOtherTextChange(e?.target?.value)}
              placeholder="Your answer"
              value={otherText}
              onFocus={(e) => e?.target?.select()}
              disabled={shouldBeReadOnly}
            />
          </Box>
        )}

        {isShowActionMessage && (
          <Box mt={1}>
            <AlertMessage alertMessage={element?.actionMessage} />
          </Box>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default CheckboxFormFieldPreview;
